<script setup>
import { computed } from "vue";

const props = defineProps({
  percentage: {
    type: Number,
    required: true,
    validator: (value) => value >= 0 && value <= 100,
  },
  redThreshold: {
    type: Number,
    default: 30,
  },
  yellowThreshold: {
    type: Number,
    default: 79,
  },
  size: {
    type: Number,
    default: 100,
  },
  strokeWidth: {
    type: Number,
    default: 10,
  }
});

const radius = computed(() => (props.size / 2) - props.strokeWidth);
const circumference = computed(() => 2 * Math.PI * radius.value);

const strokeDashoffset = computed(() => {
  return circumference.value - (props.percentage / 100) * circumference.value;
});

const progressColor = computed(() => {
  if (props.percentage <= props.redThreshold) {
    return "#DE301D";
  } else if (props.percentage <= props.yellowThreshold) {
    return "#F1C40F";
  } else {
    return "#2ECC71";
  }
});
</script>

<template>
  <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
    <circle
        class="circular-progress"
        :stroke-width="strokeWidth"
        stroke="currentColor"
        fill="transparent"
        :r="radius"
        :cx="size / 2"
        :cy="size / 2"
    />

    <circle
        :stroke="progressColor"
        :stroke-width="strokeWidth"
        fill="transparent"
        :r="radius"
        :cx="size / 2"
        :cy="size / 2"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="strokeDashoffset"
        stroke-linecap="round"
        :transform="`rotate(-90 ${size / 2} ${size / 2})`"
    />

    <text
        :x="size / 2"
        :y="size / 2 + strokeWidth / 2"
        text-anchor="middle"
        class="font-bold circular-progress-text"
        :style="{ fontSize: `${size / 5}px` }"
    >
      {{ percentage }}%
    </text>
  </svg>
</template>
<style scoped>
.circular-progress {
  color: #e5e7eb;
}
.circular-progress-text {
  fill: #111827;
}
</style>